var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4846 0H3.48462C2.68897 0 1.92591 0.31607 1.3633 0.87868C0.80069 1.44129 0.484619 2.20435 0.484619 3L0.484619 11C0.484619 11.7956 0.80069 12.5587 1.3633 13.1213C1.92591 13.6839 2.68897 14 3.48462 14H15.4846C16.2803 14 17.0433 13.6839 17.6059 13.1213C18.1685 12.5587 18.4846 11.7956 18.4846 11V3C18.4846 2.20435 18.1685 1.44129 17.6059 0.87868C17.0433 0.31607 16.2803 0 15.4846 0V0ZM3.48462 1H15.4846C16.0151 1 16.5238 1.21071 16.8988 1.58579C17.2739 1.96086 17.4846 2.46957 17.4846 3V3.2L9.48462 7.434L1.48462 3.2V3C1.48462 2.46957 1.69533 1.96086 2.07041 1.58579C2.44548 1.21071 2.95419 1 3.48462 1ZM15.4846 13H3.48462C2.95419 13 2.44548 12.7893 2.07041 12.4142C1.69533 12.0391 1.48462 11.5304 1.48462 11V4.331L9.25062 8.442C9.32271 8.48018 9.40304 8.50014 9.48462 8.50014C9.56619 8.50014 9.64653 8.48018 9.71862 8.442L17.4846 4.331V11C17.4846 11.5304 17.2739 12.0391 16.8988 12.4142C16.5238 12.7893 16.0151 13 15.4846 13Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9445310d6606d685b1aa26269db73d31.svg";
export { ForwardRef as ReactComponent };